/**
 * Utility functions for workflow execution status badge colors.
 * Maps WorkflowExecutionStatus enum values to CloudScape badge colors.
 */

import { WorkflowExecutionStatus } from '@amzn/finspace-service-typescript-client';
import { BadgeColor } from '../constants/reportConstants';

/**
 * Gets the appropriate badge color for workflow execution status
 */
export const getStatusBadgeColor = (status: WorkflowExecutionStatus | undefined): BadgeColor => {
  switch (status) {
    case WorkflowExecutionStatus.SUCCEEDED:
      return BadgeColor.GREEN;
    case WorkflowExecutionStatus.EXECUTION_IN_PROGRESS:
    case WorkflowExecutionStatus.REPORT_GENERATION_IN_PROGRESS:
    case WorkflowExecutionStatus.PENDING:
    case WorkflowExecutionStatus.USER_INPUT_REQUIRED:
      return BadgeColor.BLUE;
    case WorkflowExecutionStatus.FAILED:
      return BadgeColor.RED;
    default:
      return BadgeColor.GREY;
  }
};
